/* @flow */

import {combineReducers} from 'redux';

import {creatorReducer, type CreatorState} from './creator';
import {
    emailComposerReducer,
    type EmailComposerState,
    emailReplyReducer,
    type EmailReplyState,
} from './email';
import {tasksReducer, type CreatorTasksState} from './tasks';
import {messagesReducer, type MessagesState} from './messages';
import {sidebarReducer, type SidebarState} from './sidebar/sidebar-reducer';
import {SalesAutomationUi, type SalesAutomationUiState} from './sales-automation';
import {TinyIntroduction, type TinyIntroState} from './auth';
import {trialReducer, type TrialState} from './trial';
import {connectedFormsReducer, type ConnectedFormsState} from './connected-forms';
import {analyticsModalReducer, type AnalyticsModalState} from './setup/analytics';
import {attributionModalReducer, type AttributionModalState} from './setup/sources/onboarding';
import {
    visitorsSidebarReducer,
    type VisitorsSidebarState,
} from './email-marketing/visitors/visitors-sidebar';

export type UiState = {
    creator: CreatorState,
    tasks: CreatorTasksState,
    salesAutomation: SalesAutomationUiState,
    tinyIntroduction: TinyIntroState,
    sidebar: SidebarState,
    emailComposer: EmailComposerState,
    emailReply: EmailReplyState,
    messages: MessagesState,
    trial: TrialState,
    connectedForms: ConnectedFormsState,
    analyticsModal: AnalyticsModalState,
    attributionModal: AttributionModalState,
    visitorsSidebar: VisitorsSidebarState,
};

// $FlowFixMe upgrading Flow to v0.92.1 on web
export const uiReducer = combineReducers({
    creator: creatorReducer,
    tasks: tasksReducer,
    salesAutomation: SalesAutomationUi.uiReducer,
    tinyIntroduction: TinyIntroduction.tinyIntroReducer,
    sidebar: sidebarReducer,
    emailComposer: emailComposerReducer,
    emailReply: emailReplyReducer,
    messages: messagesReducer,
    trial: trialReducer,
    connectedForms: connectedFormsReducer,
    analyticsModal: analyticsModalReducer,
    attributionModal: attributionModalReducer,
    visitorsSidebar: visitorsSidebarReducer,
});
